import type { DataNotification, GNotificationProps, NotificationContextProps } from '../types';
import type React from 'react';

import { createContext, useContext, useMemo, useState } from 'react';

const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export const useGNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const GNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<GNotificationProps['data']>([]);

  const handleSetNotification = (data: DataNotification) => {
    setNotifications((prevNotifications) => {
      const existingNotificationIndex = prevNotifications.findIndex((item) => item.id === data.id);

      if (existingNotificationIndex !== -1) {
        const updatedNotifications = [...prevNotifications];
        updatedNotifications[existingNotificationIndex] = data;
        return updatedNotifications;
      }

      return [...prevNotifications, data];
    });
  };
  const handleSetNotifications = (dataNotifications: DataNotification[]) => {
    dataNotifications.map((data) => handleSetNotification(data));
  };

  const removeNotificationById = (id: string) => {
    const newValue = notifications.filter((item) => item.id !== id);
    setNotifications(newValue);
  };

  const resetNotification = () => {
    setNotifications([]);
  };

  const contextValue = useMemo<NotificationContextProps>(
    () => ({
      notifications,
      handleSetNotification,
      handleSetNotifications,
      removeNotificationById,
      resetNotification,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [notifications],
  );

  return (
    <NotificationContext.Provider value={contextValue}>{children}</NotificationContext.Provider>
  );
};
